import React from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import SiteSurveyResponseForm from '../../../components/forms/SiteSurveyResponseForm';
import { useSiteSurveyResponseById, useUpdateSiteSurveyResponse } from '../../../hooks/useSiteSurveyResponseApi';
import { useNavigate, useParams } from 'react-router-dom';

const SiteSurveyResponseEdit: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const { data: entityData, isLoading } = useSiteSurveyResponseById(id!);
  const updateSiteSurveyResponse = useUpdateSiteSurveyResponse();
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Site Survey Responses', href: '/admin/sitesurveyresponses' },
    { label: 'Edit', href: '#' },
  ];

  const handleSubmit = async (data: any) => {
    try {
      await updateSiteSurveyResponse.mutateAsync({ id: id!, data });
      navigate('/admin/sitesurveyresponses');
    } catch (error) {
      console.error('Error updating SiteSurveyResponse:', error);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/sitesurveyresponses"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission='Settings.SiteSurveyResponse.Edit'
    >
      {entityData ? (
        <SiteSurveyResponseForm
          initialValues={entityData}
          onSubmit={handleSubmit}
          onCancel={() => navigate('/admin/sitesurveyresponses')}
        />
      ) : (
        <p>Loading...</p>
      )}
    </AdminLayout>
  );
};

export default SiteSurveyResponseEdit;
